<template>
  <p-product-detail-block v-if="html" data-test="html-block" :title="title">
    <div
      :class="{
        'product-detail-block-html__html-content': !formatHtml,
        'product-detail-block-html__html-content-formatted': formatHtml,
      }"
    >
      <adn-text-area :initial-value="html" :edition="false" data-test="adn-text-area" />
    </div>
  </p-product-detail-block>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import AdnTextArea from '@b2ag/design-system/src/components/AdnTextArea/AdnTextArea.vue'
import PProductDetailBlock from '../PProductDetailBlock/PProductDetailBlock.vue'

export default defineComponent({
  name: 'PProductDetailBlockHtml',
  components: {
    PProductDetailBlock,
    AdnTextArea,
  },
  props: {
    title: {
      type: String,
    },
    html: {
      type: String,
      default: null,
    },
    formatHtml: {
      type: Boolean,
      default: false,
    },
  },
})
</script>

<style lang="scss">
.product-detail-block-html__html-content {
  white-space: pre-line;
}

.product-detail-block-html__html-content-formatted {
  white-space: pre-line;

  a {
    font-weight: bold;
    text-decoration: underline;
  }

  ul,
  ol {
    list-style-position: outside;
    padding-left: 1.6rem;
  }

  ul {
    list-style-type: disc;

    ul {
      list-style-type: circle;

      ul {
        list-style-type: square;
      }
    }
  }

  ol {
    list-style-type: decimal;

    ol {
      list-style-type: lower-alpha;

      ol {
        list-style-type: lower-roman;
      }
    }
  }

  table {
    width: 100%;
    overflow: hidden;
  }

  th,
  td {
    border: 1px solid #e0e0e0;
    padding: 1rem 1rem;
  }
}
</style>
